import React, { useEffect, useState } from "react";
import { QqPageComponentProps } from "./qq-page.props";
import { QqStateType } from "../../message-interop/qq-state.type";
import { useStyles } from "../../utils/styles.hook";
import { Container, CssBaseline, Grid } from "@mui/material";
import { QqDispatchType } from "../../message-interop/qq-dispatch.type";
import { MessageProcessorFactory } from "../../message-interop/message-processor/message-processor.factory";
import { QuizPaneComponent } from "../pane/quiz.pane.component";
import { RecommendationPaneComponent } from "../pane/recommendation.pane.component";
import {
  SubTitleTypography,
  PageTitleTypography,
} from "../../controls/qq-typohraphy.controls";

import logo from "../../resources/img/cloud-logo.svg";
import Box from "@mui/material/Box";
import { QqBundleService } from "../../services/qq-bundle.service";
import { vmDecision } from "../../data/vm-decision.data";

export const QqPageComponent: React.FunctionComponent<QqPageComponentProps> =
  () => {
    const classes = useStyles();

    const [qqState, setQqState] = useState<QqStateType>({
      ctrlBundle: {},
      qqBundle: vmDecision(),
      currentValues: {},
      currentOptions: {},
      ctrlPos: {},
    });

    const questions = qqState.qqBundle;

    useEffect(() => {
      const bundleService = new QqBundleService(questions);
      const { currentValues, currentOptions, ctrlPos, ctrlBundle } =
        bundleService.fillDefault(questions);

      setQqState({
        ctrlBundle: ctrlBundle,
        qqBundle: questions,
        currentValues: currentValues,
        currentOptions: currentOptions,
        ctrlPos: ctrlPos,
      });
    }, [questions]);

    const dispatch: QqDispatchType = (action) => {
      const processor = new MessageProcessorFactory();
      const newState = processor.process(action, qqState);

      if (newState !== qqState) {
        setQqState(newState);
      }
    };

    return (
      <div className={classes.root}>
        <CssBaseline />
        <Grid container>
          <Grid
            item
            sm={12}
            xs={12}
            sx={{
              boxShadow: 1,
              marginBottom: "12px",
            }}
          >
            <Container style={{ height: "50px" }}>
              <img
                src={logo}
                alt="logo"
                style={{
                  width: "120px",
                  position: "relative",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              />
            </Container>
          </Grid>
        </Grid>
        <Container
          sx={{
            flexGrow: 1,
          }}
        >
          <Grid container>
            <Grid item sm={6}>
              <PageTitleTypography>Machine family selector</PageTitleTypography>
              <SubTitleTypography>
                To help you find the best configuration, answer as many of the
                following questions as you can
              </SubTitleTypography>
            </Grid>
            <Grid item sm={6} xs={false} />
            <Grid item sm={6} xs={12}>
              <QuizPaneComponent state={qqState} dispatch={dispatch} />
            </Grid>
            <Grid item sm={1} xs={false} />
            <Grid item sm={5} xs={12}>
              <RecommendationPaneComponent
                state={qqState}
                dispatch={dispatch}
              />
            </Grid>
          </Grid>
        </Container>

        <Grid container>
          <Grid
            item
            sm={12}
            xs={12}
            sx={{
              boxShadow: 1,
              marginTop: "12px",
            }}
          >
            <Container sx={{ height: "50px" }}>
              <Box
                sx={{
                  position: "relative",
                  top: "50%",
                  transform: "translateY(-50%)",
                }}
              >
                About Google | Privacy | Site terms | Google Cloud terms
              </Box>
            </Container>
          </Grid>
        </Grid>
      </div>
    );
  };
